module.exports = __webpack_public_path__ + "img/praise_gray.074d612c.png";